import request from './request'

/**
 * 发起退款申请
 * 对应后端接口：POST /api/payment/refund/apply
 *
 * @param {object} data
 * @param {number} data.billingId - 账单ID
 * @param {number} data.refundAmount - 退款金额（元）
 * @param {string} [data.refundReason] - 退款原因（不超过32个字符）
 * @returns {Promise<object>} 退款申请单（含审批实例ID）
 */
export function applyRefund(data) {
  return request.post('/payment/refund/apply', data)
}

/**
 * 查询账单退款记录与派生退款展示态
 * 对应后端接口：GET /api/payment/refund/by-billing/{billingId}
 *
 * @param {number} billingId - 账单ID
 * @returns {Promise<object>} { billingId, refundStatus, totalRefundedAmount, inFlightRefundAmount, applies }
 */
export function getBillingRefundView(billingId) {
  return request.get(`/payment/refund/by-billing/${billingId}`)
}

/**
 * 按审批实例查询退款申请（审批详情页业务数据渲染）
 * 对应后端接口：GET /api/payment/refund/by-approval-instance/{instanceId}
 */
export function getRefundByApprovalInstanceId(instanceId) {
  return request.get(`/payment/refund/by-approval-instance/${instanceId}`)
}

/**
 * 撤销退款申请（申请人，审批中可撤）
 * 对应后端接口：POST /api/payment/refund/{applyId}/cancel
 */
export function cancelRefund(applyId) {
  return request.post(`/payment/refund/${applyId}/cancel`)
}

/**
 * 查询待人工处理退款单
 * 对应后端接口：GET /api/payment/refund/manual-required
 */
export function getManualRequiredRefunds(limit) {
  return request.get('/payment/refund/manual-required', { params: { limit } })
}

/**
 * 完成人工处理退款单（仅清标志位，不重置重试次数）
 * 对应后端接口：POST /api/payment/refund/manual-required/complete
 */
export function completeManualRequiredRefund(data) {
  return request.post('/payment/refund/manual-required/complete', data)
}
